export const today = new Date();

export const maxFutureLicenceExpiryDate = () => {
  const year = today.getFullYear();
  const month = today.getMonth();
  const day = today.getDate();
  return new Date(year + 15, month, day);
};
